/*
    锁仓订单状态
*/
export const lockOrderState = {
    0: '已取消',
    1: '已锁仓',
    2: '待同意',
    3: '超时失效',
    4: '未同意',
    5: '已转为下单'
}
export const liquidationState = {
    1: '取消/关闭',
    2: '已发起清算,请退货',
    3: '生产商同意退货数量',
    4: '生产商拒绝退货数量',
    5: '已发起退货,等待供应商同意',
    6: '清算完成'
}




// WEBPACK FOOTER //
// ./src/common/order-state.js